import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Custom tailwind-merge config. Without this, `twMerge` does not know
 * about our token-backed font-size classes (`text-display`, `text-h1`,
 * `text-body`, `text-ui`, `text-meta`, `text-micro`) and collapses
 * them into the text-color group — dropping either the size or the
 * color when both are present on the same element.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display', 'h1', 'h2', 'h3', 'body', 'ui', 'meta', 'micro'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
